import { FC } from 'react';
import { DefaultOptionType } from 'antd/lib/select';
import { FormInstance } from 'antd/es/form/Form';
import { Icon } from 'components/atoms/Icons';
import SwitchAtom from 'components/atoms/SwitchAtom';
import FormAtom from 'components/atoms/FormAtom';
import SelectAtom from 'components/atoms/SelectAtom';
import { AlertNotificationFormValues, AlertNotificationFormValuesNames } from 'functionalities/deviceAlertNotifications/components/AlertNotificationDrawer/config';
import './styles.scss';

const ICON_SIZE = 24;

export interface Props {
  form: FormInstance<AlertNotificationFormValues>;
  initialValues: AlertNotificationFormValues;
  userList: DefaultOptionType[];
  literals: Record<string, string>;
  onFinish: (values: AlertNotificationFormValues) => void;
  onFinishFailed: () => void;
}

const AlertNotificationForm: FC<Props> = ({
  form,
  initialValues,
  userList,
  literals: {
    infoText,
    enabledLabel,
    requiredFieldText,
    userListLabel,
    userListPlaceholder,
  },
  onFinish,
  onFinishFailed,
}) => {
  return (
    <main>
      <div className={'AlertNotificationForm__info'}>
        <div className={'AlertNotificationForm__info-icon'}>
          <Icon.InfoCircleFilled style={{ fontSize: ICON_SIZE }} />
        </div>
        <div>
          <p className={'AlertNotificationForm__info-text'}>{infoText}</p>
        </div>
      </div>
      <FormAtom
        form={form}
        layout={'vertical'}
        onFinish={onFinish}
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >
        <FormAtom.Item
          className={'AlertNotificationForm__switch'}
          label={enabledLabel}
          name={AlertNotificationFormValuesNames.ENABLED}
          rules={[{ required: true, message: requiredFieldText }]}
        >
          <SwitchAtom defaultChecked={form.getFieldValue(AlertNotificationFormValuesNames.ENABLED)} />
        </FormAtom.Item>
        <FormAtom.Item
          label={userListLabel}
          name={AlertNotificationFormValuesNames.USER_LIST}
        >
          <SelectAtom
            mode={'multiple'}
            options={userList}
            placeholder={userListPlaceholder}
            showSearch
            filterOption={(input: string, option?: DefaultOptionType) => (option?.label as string || '').toLowerCase().includes(input.toLowerCase())}
          />
        </FormAtom.Item>
      </FormAtom>
    </main>
  );
}

export default AlertNotificationForm;